// extracted by mini-css-extract-plugin
export var documentation = "_jc-1";
export var menu = "_jc-0";